const SET_SUBJECTS = 'SET_SUBJECTS';

export {
	SET_SUBJECTS,
};
